const filters = {
  ALL: 'ALL',
  ACTIVE: 'ACTIVE',
  COMPLETE: 'COMPLETE'
}

const todoList = {
  SET_FILTER: 'SET_FILTER',
  ADD_TODO: 'ADD_TODO',
  REMOVE_TODO: 'REMOVE_TODO',
  CLEAR_COMPLETED: 'CLEAR_COMPLETED',
  DEHYDRATE: 'DEHYDRATE',
  REHYDRATE: 'REHYDRATE'
}

const todoItem = {
  UPDATE_TITLE: 'UPDATE_TITLE',
  MARK_COMPLETE: 'MARK_COMPLETE',
  MARK_ACTIVE: 'MARK_ACTIVE',
  START_EDITING: 'START_EDITING',
  STOP_EDITING: 'STOP_EDITING'
}

const ENTER = 13

export {filters, todoList, todoItem, ENTER}



// WEBPACK FOOTER //
// ./src/Todos/constants.js